import { Column } from '@ru-digital-assets/ui-component/dist/stories/table';
import {
  ISignerInfo,
  SignerPermissons,
  PermissionToLabel,
} from 'constants/signers';
import PermissionStatus from './PermissionStatus';

export const getColumns = (): Column<ISignerInfo>[] => {
  return [
    {
      title: 'ФИО',
      name: 'fio',
      headerStyle: {
        width: '25%',
      },
      dataGetter: (data) => data,
      Component: ({ data }: { data: ISignerInfo }) => {
        return (
          <div>
            <p className="p">{data.displayName}</p>
            {data.isMainSigner && (
              <p className="p p_font-size_12 p_color_blue">
                Главный уполномоченный
              </p>
            )}
          </div>
        );
      },
    },
    {
      title: 'Должность',
      name: 'rank',
      headerStyle: {
        width: '25%',
      },
      dataGetter: (data) => data.rank,
    },
    {
      title: 'Полномочия',
      name: 'permissions',
      headerStyle: {
        width: '25%',
        flexGrow: 1,
      },
      dataGetter: (data) => data,
      Component: ({ data }: { data: ISignerInfo }) => {
        return (
          <div>
            {SignerPermissons.COURT_ENFORCEMENT in data.permissions && (
              <p className="p p_font-size_14 signers-tab__permission">
                {PermissionToLabel[SignerPermissons.COURT_ENFORCEMENT]}
              </p>
            )}
            {SignerPermissons.SIGNING_AUTHORITY in data.permissions && (
              <p className="p p_font-size_14 signers-tab__permission">
                {PermissionToLabel[SignerPermissons.SIGNING_AUTHORITY]}
              </p>
            )}
          </div>
        );
      },
    },
    {
      title: 'Статус полномочий',
      name: 'status',
      headerStyle: {
        width: '180px',
      },
      dataGetter: (data) => data,
      Component: ({ data }: { data: ISignerInfo }) => {
        return (
          <div className="ml_20">
            {SignerPermissons.COURT_ENFORCEMENT in data.permissions && (
              <div className="signers-tab__permission">
                <PermissionStatus
                  permission={
                    data.permissions[SignerPermissons.COURT_ENFORCEMENT]
                  }
                />
              </div>
            )}
            {SignerPermissons.SIGNING_AUTHORITY in data.permissions && (
              <div className="signers-tab__permission">
                <PermissionStatus
                  permission={
                    data.permissions[SignerPermissons.SIGNING_AUTHORITY]
                  }
                />
              </div>
            )}
          </div>
        );
      },
    },
  ];
};
